import { createTheme } from '@material-ui/core/styles';

const rebaTheme = createTheme({
  typography: {
    fontFamily: [
      'Arial, Helvetica Neue, Helvetica, sans-serif'
    ]
  },
  overrides: {
    MuiStepIcon: {
      root: {
        '&$completed': {
          color: 'green'
        }
      }
    },
    MuiCardContent: {
      root: {
        padding: 16,
        '&:last-child': {
          paddingBottom: 16
        }
      }
    }
  },
  palette: {
    primary: {
      main: '#095489'
    },
    secondary: {
      main: '#6f7780'
    },
    text: {
      primary: '#4a4a4a'
    }
  }
})

export default rebaTheme
